const actions = {
	getData (context) {
		context.commit('getData')
	}
}

export default actions;


// WEBPACK FOOTER //
// ./src/store/actions.js